import { InputSwitch } from "primereact/inputswitch";
import { Controller, useFormContext } from "react-hook-form";

/** CLE-3015 — Clear Certified self-serve training. Default off. */
export function Training() {
  const { control } = useFormContext<any>();

  return (
    <div className="flex flex-column gap-4 border-bottom-1 border-gray-200 pb-4">
      <span className="font-medium text-sm mb-2 text-gray-600">TRAINING</span>
      <div className="flex gap-3">
        <Controller
          name="features.clearCertifiedTraining"
          control={control}
          render={({ field: { onChange, value } }) => (
            <InputSwitch
              inputId="features.clearCertifiedTraining"
              checked={value || false}
              onChange={(e) => onChange(!!e.value)}
            />
          )}
        />
        <div className="flex flex-column">
          <label
            htmlFor="features.clearCertifiedTraining"
            className="font-medium text-sm mb-1"
          >
            Clear Certified training
          </label>
          <span className="text-sm text-gray-500">
            Show this hospital&apos;s staff the &quot;Get Clear Certified&quot;
            banner and in-app training
          </span>
        </div>
      </div>
    </div>
  );
}
